// @flow
import React from 'react'
import Date from './Date'

const OpportunityDate = ({
  startDateUtc,
  expireDateUtc,
  live,
}: {
  startDateUtc: ?string,
  expireDateUtc: ?string,
  live: boolean,
}) => {
  if (!live) {
    return <span>Not live</span>
  }
  if (live && !expireDateUtc) {
    return <span>Ongoing</span>
  }

  if (live && startDateUtc && expireDateUtc) {
    return (
      <span><Date date={startDateUtc} /> - <Date date={expireDateUtc} /></span>
    )
  }

  if (live && startDateUtc) {
    return <span>Starts <Date date={startDateUtc} /></span>
  }
  if (live && expireDateUtc) {
    return <span>Ends <Date date={expireDateUtc} /></span>
  }
  return null
}

export default OpportunityDate



// WEBPACK FOOTER //
// ./src/components/OpportunityDate.js